import axios from 'axios'
import store from './store'
import properties from "./properties";
import utils from "./utilities";


export const BASE_URL = process.env.VUE_APP_API_ENDPOINT;
const url = 'http://192.168.178.4:8080';

let requests = {

    login(username, password, loginCallBack, failedLoginCallBack) {

        var querystring = require('querystring');

        axios.post(BASE_URL + 'rest/user/login', querystring.stringify({
                username: username,
                password: password
            }),
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            })
            .then((response) => {
                loginCallBack(response.data);
            })
            .catch((error) => {
                store.commit('setLoadingModal', false);
                failedLoginCallBack(error.response.data);
                console.log(error);
            })
    },

    get(path, getCallBack) {

        axios.get(BASE_URL + path,
            {headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('token')
                }})
            .then((response =>{
                getCallBack(response.data)
            }))
            .catch((error => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            }))
    },

    gete(path, getCallBack) {

        axios.get(path,
            {headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('token')
                }})
            .then((response =>{
                getCallBack(response.data)
            }))
            .catch((error => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            }))
    },

    post(path, data,  postCallBack) {

        axios.post(BASE_URL + path,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('token')
                }
            })
            .then((response =>{
                postCallBack(response.data)
            }))
            .catch((error => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            }))
    },

    putForFiles(path, data) {

        axios.put(BASE_URL + path,
            data,
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('token')
                }
            })
            .then((response =>{
                store.commit('setLoadingModal', false);
                utils.downLoadPDFNewTabWithFilename(response);
            }))
            .catch((error => {
                const binaryString = atob(error.response.headers.errormessage);

                // Convert binary string to UTF-8 text
                const decodedErrorMessage = decodeURIComponent(escape(binaryString));
                var storeObj = {
                    title: 'Σφάλμα!',
                    text: decodedErrorMessage,
                    color: 'indianRed',
                    class: 'white--text indianRed text-center justify-center'
                };
                
                store.commit('setErrorPopup', true);
                store.commit('setErrorPopupProps', storeObj);
                store.commit('setLoadingModal', false);
            }))
    },

    postForFiles(path, data,  postCallBack) {

        axios.post(BASE_URL + path,
            data,
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('token')
                }
            })
            .then((response =>{
                postCallBack(response)
            }))
            .catch((error => {
                var storeObj = {
                    title: 'Σφάλμα!',
                    text: 'Κάτι πήγε στραβά κατά τη δημιουργία αναφοράς.',
                    color: 'error',
                    class: 'white--text error text-center justify-center'
                };
                if (error.response.status==405)
                    storeObj.text = 'Για να κατέβει η αναφορά θα πρέπει να έχει προηγηθεί είτε \"Προσωρινή αποθήκευση\" είτε \"Οριστική υποβολή\".';
                store.commit('setErrorPopup', true);
                store.commit('setErrorPopupProps', storeObj);
                store.commit('setLoadingModal', false);
            }))
    },

    put(path, data ,  putCallBack) {

        axios.put(BASE_URL + path, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('token')
                }
            }
        )
        .then((response =>{
            putCallBack(response.data)
        }))
        .catch((error => {
            properties.getErrorMessage(error.response.data);
            store.commit('setLoadingModal', false);
        }))
    },

    uploadBookToBookstore(bookId ,mimeType, callBack) {

        axios.post(BASE_URL + 'rest/books/upload-book-to-qnr', bookId,
            {
                headers: {
                    'Authentication': utils.getLocalStorage('token'),
                    'Content-Type': 'application/json',
                    'Book-Mime': mimeType
                }
            })
            .then((response) => {
                callBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },


    //http://127.0.0.1:8080/publisherapp2/rest/user/logout

    logout(token, logoutCallBack) {

        axios.delete( BASE_URL + 'rest/user/logout',  {
            headers: {
                'Authentication': token
            }
        })
            .then((response) =>{
                logoutCallBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    //http://127.0.0.1:8080/publisherapp2/rest/books/academic-years
    getYears(token, getYearsCallBack) {

        axios.get(BASE_URL + 'rest/books/academic-years', {
            headers: {
                'Authentication': token
            }
        })
            .then((response) => {
                getYearsCallBack(response.data)
            })
            .catch((error) => {
                store.commit('setLoadingModal', false);
                console.log(error);
            })
    },

    homePageInformation(token, homePageInformationCallBack) {

        axios.get(BASE_URL + 'rest/user/publisher-home', {
            headers: {
                'Authentication': token
            }
        })
            .then((response) => {
                homePageInformationCallBack(response.data);
            })
            .catch((error) => {
                store.commit('setLoadingModal', false);
                store.commit('setloginModal', true);
            })
    },

    // http://127.0.0.1:8080/publisherapp2/rest/books/publisherbooks
    getAllPublisherBooks(token, getAllPublisherBooksCallBack) {

        axios.get(BASE_URL + 'rest/books/publisher-books', {
            headers: {
                'Authentication': token,
            }
        })
            .then((response) => {
                getAllPublisherBooksCallBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
                console.log(error);
            })
    },

//    http://127.0.0.1:8080/publisherapp2/rest/books/editbook
    editBook(token, book, editBookCallBack) {

        axios.put(BASE_URL + 'rest/books/edit-book', book,
            {
                headers: {
                    'Authentication': token
                }
            })
            .then((response) => {
                editBookCallBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    //http://127.0.0.1:8080/publisherapp2/rest/books/add-book
    addNewBook(token, bookObj, addNewBookCallBack) {

        axios.post(BASE_URL + 'rest/books/add-book', {},
            {
                data: bookObj,
                headers: {
                    'Authentication': token
                }
            })
            .then((response) => {
                addNewBookCallBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
                console.log(error);
            })
    },

//    http://127.0.0.1:8080/publisherapp2/rest/books/remove-book
    deleteBook(token, bookId, deleteBookCallBack) {

        axios.delete(BASE_URL + 'rest/books/remove-book/',
            {
                data: bookId,
                headers: {
                    'Authentication': token,
                    'Content-Type': 'application/json'
                },
            })
            .then((response) => {
                deleteBookCallBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

//    http://127.0.0.1:8080/publisherapp2/rest/books/add-volume
    addVolume(token, masterVolumeId, addVolumeCallBack) {

        axios.post(BASE_URL + 'rest/books/add-volume', masterVolumeId,
            {
                headers: {
                    'Authentication': token,
                    'Content-Type': 'application/json'
                }
            })
            .then((response) => {
                addVolumeCallBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

//    http://127.0.0.1:8080/publisherapp2/rest/books/add-edition
    addEdition(token, currentEditionID, addEditionCallBack) {

        axios.post(BASE_URL + 'rest/books/add-edition', currentEditionID,
            {
                headers: {
                    'Authentication': token,
                    'Content-Type': 'application/json'
                }
            })
            .then((response) => {
                addEditionCallBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

//    upload file to servlet
    upLoadFileToServlet(token, type, bookId,  file, upLoadFileToServletCallBack) {

        axios.post(BASE_URL + 'upload/', file,  {
            onUploadProgress: progressEvent => console.log( Math.round( (progressEvent.loaded * 100) / progressEvent.total )),
                headers: {
                    'Authentication': token,
                    'Content-Type': 'multipart/form-data'
                },
                params: {
                    bookId,
                    type
                }
            })
            .then((response) => {
                upLoadFileToServletCallBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
            })
    },

    uploadSolemnDeclaration(token, file, upLoadSolemnDeclarationCallBack) {

        axios.post(BASE_URL + 'uploadDeclaration/', file,  {
            onUploadProgress: progressEvent => console.log( Math.round( (progressEvent.loaded * 100) / progressEvent.total )),
                headers: {
                    'Authentication': token,
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                upLoadSolemnDeclarationCallBack(response.data)
            })
            .catch((error) => {
                store.commit('setLoadingModal', false);
                properties.getErrorMessage(error.response.data);
            })
    },

    uploadDistributionFile(token, file, upLoadDistributionFileCallBack) {

        axios.post(BASE_URL + 'uploadDistributionFile/', file,  {
            onUploadProgress: progressEvent => console.log( Math.round( (progressEvent.loaded * 100) / progressEvent.total )),
                headers: {
                    'Authentication': token,
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                upLoadDistributionFileCallBack(response.data)
            })
            .catch((error) => {
                store.commit('setLoadingModal', false);
                properties.getErrorMessage(error.response.data);
            })
    },

    //http://127.0.0.1:8080/publisherapp/rest/books/remove-book-related-file
    deletefileFromServer(token, fileObjc, deletefileFromServerCallBack) {

        axios.delete( BASE_URL + 'rest/books/remove-book-related-file',  {
            data:fileObjc,
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) =>{
                deletefileFromServerCallBack(response.data)
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

//    copy selected dist points to next year
    copyDistPoints(token, copyDistPointsCallBack) {

        axios.put(BASE_URL + 'rest/coursebooks/copy-dist-points', null, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
        .then((response) => {
            copyDistPointsCallBack(response.data)
        })
        .catch((error) => {
            properties.getErrorMessage(error.response.data);
            store.commit('setLoadingModal', false);
        })

    },

//    get all distribution Point
    getAllDistPoint(token, getAllDistPointCallBack) {

        axios.get(BASE_URL + 'rest/distribution-points/all', {
            headers: {
                'Authentication': token,
            }
        })
            .then((response) => {
                getAllDistPointCallBack(response.data)
            })
            .catch((error) => {
                store.commit('setLoadingModal', false);
            })
    },

//   get selected distPoint
    getSelectedDistPoint(token, getSelectedDistPointCallBack) {

        axios.get(BASE_URL + 'rest/distribution-points/selected', {
            headers: {
                'Authentication': token,
            }
        })
            .then((response) => {
                getSelectedDistPointCallBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    addDistPoint(token, id, addDistPointCallBack, addDistPointError) {

        axios.put(BASE_URL + 'rest/distribution-points/add-distribution-points-to-publisher', id, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                addDistPointCallBack(response.data)
            })
            .catch((error) => {
                addDistPointError(error.response.data);
            })
    },

    removeDistPoint(requestObj, removeDistPoint, removeDistPointError) {
        
        axios.put(BASE_URL + 'rest/distribution-points/remove-distribution-points-from-publisher', requestObj, {
            headers: {
                'Authentication': utils.getLocalStorage('token'),
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                removeDistPoint(response.data)
            })
            .catch((error) => {
                removeDistPointError(error.response.data);
            })
    },

    getdistributionPointAvailability(token, distributionPointId, year, getdistributionPointAvailabilityCallBack) {

        axios.post(BASE_URL + 'rest/distribution-points/distribution-point-availability', {
            distributionPointId: distributionPointId,
            year: year
        }, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'

            }
        })
            .then((response) => {
                getdistributionPointAvailabilityCallBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    getStockCsvTemplate(token, getStockCsvTemplateCallBack) {

        axios.get(BASE_URL + 'rest/distribution-points/book-availability-template', {
            responseType: 'blob',
            headers: {
                'Authentication': token,
            }
        })
            .then((response) => {
              utils.downloadCsv(response.data, 'stock_update_template.csv');
              getStockCsvTemplateCallBack(response.data);
            })
            .catch((error) => {
                properties.getErrorMessage(error.response);
                store.commit('setLoadingModal', false);
            })
    },

    getStockCsvErrors(token, getStockCsvErrorsCallBack) {

        axios.get(BASE_URL + 'rest/distribution-points/book-availability-errors', {
            responseType: 'blob',
            headers: {
                'Authentication': token,
            }
        })
            .then((response) => {
              utils.downloadCsv(response.data, 'stock_update_errors.csv');
              getStockCsvErrorsCallBack(response.data);
            })
            .catch((error) => {
                if (error.response?.statusCode !== 404) // Indicates no error file exists, ignore error in this case
                    properties.getErrorMessage(error.response);
                store.commit('setLoadingModal', false);
            })
    },

    getStockExportXlsx(token, year, getStockExportXlsxCallBack) {

        axios.get(BASE_URL + 'rest/distribution-points/stock-export?year=' + year, {
            responseType: 'blob',
            headers: {
                'Authentication': token,
            }
        })
            .then((response) => {
              utils.downloadXlsxFile(response.data, 'apothema_' + year + '.xlsx');
              getStockExportXlsxCallBack(response.data);
            })
            .catch((error) => {
                properties.getErrorMessage(error.response);
                store.commit('setLoadingModal', false);
            })
    },

    uploadStockCsv(token, file, uploadStockCsvCallback, uploadStockCsvErrorCallback) {

        axios.put(BASE_URL + 'rest/distribution-points/mass-update-book-availability', file, {
            headers: {
                'Authentication': token,
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
              uploadStockCsvCallback(response.data);
            })
            .catch((error) => {
              if (error.response.status === 422) {
                uploadStockCsvErrorCallback(error);
              }
              else {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
              }
            })
    },

    // bookId , distributionPointId, year, totalIncrement
    upDateDistributionPoint(token, bookAvailabilityObject, upDateDistributionPointCallBack) {

        axios.put(BASE_URL + 'rest/distribution-points/update-book-availability', {
            bookId: bookAvailabilityObject.bookId,
            distributionPointId: bookAvailabilityObject.distributionPointId,
            year: bookAvailabilityObject.year,
            totalIncrement: bookAvailabilityObject.totalIncrement
        }, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'

            }
        })
            .then((response) => {
                upDateDistributionPointCallBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

//    http://127.0.0.1:8080/publisherapp2/rest/library-orders/year
    getLibraryOrder(token, year, getLibraryOrderCallBack) {

        axios.get(BASE_URL + 'rest/library-orders/year/' + year, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                getLibraryOrderCallBack(response.data);
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

//     http://127.0.0.1:8080/publisherapp2/rest/library-orders/library-details
    getLibraryDetails(token, id, getLibraryDetailsCallBack) {

        axios.get(BASE_URL + 'rest/library-orders/library-details/' + id, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                getLibraryDetailsCallBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);

            })
    },

    cancelLibraryOrder(token, id, cancelLibraryOrderCallBack, cancelLibraryOrderErrorCallBack) {

        axios.put(BASE_URL + 'rest/library-orders/cancel-order/' + id, null, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                cancelLibraryOrderCallBack(response.data)
            })
            .catch((error) => {
                if (cancelLibraryOrderErrorCallBack)
                    cancelLibraryOrderErrorCallBack(error.response.data);
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);

            })
    },

    completeLibraryOrder(token, libraryOrderId, pin, completeLibraryOrderCallBack, completeLibraryOrderErrorCallBack) {

        axios.put(BASE_URL + 'rest/library-orders/complete-order', {
            libraryOrderId: libraryOrderId,
            pin: pin}, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
            })
            .then((response) => {
                completeLibraryOrderCallBack(response.data)
            })
            .catch((error) => {
                if (completeLibraryOrderErrorCallBack)
                    completeLibraryOrderErrorCallBack(error.response.data);
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    getInstitution(token, year, getInstitutionCallBack){

        axios.get( BASE_URL + 'rest/coursebooks/institutions-per-year/' + year, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) =>{
                getInstitutionCallBack(response.data)
            })
            .catch((error) =>{
                store.commit('setLoadingModal', false);
            })
    },

    async getSelectedBook(token, courseBook, getSelectedBookCallBack){

        await axios.post( BASE_URL + 'rest/coursebooks/selected', {
            institutionId: courseBook.institutionId,
            year: courseBook.year,
            all: courseBook.all
        }, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            },
            timeout: 600000  //ms
        })
            .then((response) =>{
                getSelectedBookCallBack(response.data)
            })
            .catch((error) =>{
                //properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    getSelectedDistPoints(token, courseBooksDistribution, getSelectedDistPoints) {

        axios.post(BASE_URL + 'rest/coursebooks/dist-points', {
            prefectureID: courseBooksDistribution.prefectureID,
            bookID: courseBooksDistribution.bookID,
            courseID: courseBooksDistribution.courseID,
        }, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                getSelectedDistPoints(response.data);
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

//    add distribution Point
    addDistributionPoint(token, courseBookDistPoint, addDistributionPointCallBack){

        axios.post( BASE_URL + 'rest/coursebooks/dist-point-to-book', {
            bookID: courseBookDistPoint.bookID,
            courseID: courseBookDistPoint.courseID,
            distributionPointIDs: courseBookDistPoint.distributionPointIDs,
        } , {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) =>{
                addDistributionPointCallBack(response.data)
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

//    delete distribution Point
    deleteDistributionPoint(token, courseBookDistPoint, deleteDistributionPointCallBack) {

        axios.delete( BASE_URL + 'rest/coursebooks/remove-dist-point-from-book',  {
            data:courseBookDistPoint,
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) =>{
                deleteDistributionPointCallBack(response.data)
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

//    http://127.0.0.1:8080/publisherapp2/library/receipt?orderId=81770532
    printReceiptOrder(token, orderId, printReceiptOrderCallBack){

        axios.get( BASE_URL + '/library/receipt?orderId=' + orderId, {
            responseType: 'blob',
            headers: {
                'Authentication': token
            }
        })
            .then((response) => {
                printReceiptOrderCallBack(response.data)
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            } )
    },

//    http://127.0.0.1:8080/publisherapp2/rest/allocator/free-coursebooks
    getAllocatorSelectedBook(token, getAllocatorSelectedBook) {

        axios.get( BASE_URL + 'rest/allocator/free-coursebooks', {
            headers: {
                'Authentication': token
            }
        })
            .then((response) =>{
                getAllocatorSelectedBook(response.data)
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    reports(token, obj, reportsCallBack) {

        axios.post( BASE_URL + 'rest/reports/request', obj,{
            headers: {
                'Authentication': token
            }
        })
            .then((response) =>{
                reportsCallBack(response)
            })
            .catch((error) =>{
                reportsCallBack(error.response);
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    //http://127.0.0.1:8080/publisherapp2/report/
    downloadReport(token, obj, downloadReportCallBack) {

        axios.post( BASE_URL + 'report', obj,{
            responseType: 'blob',
            headers: {
                'Authentication': token
            }
        })
            .then((response) =>{
                downloadReportCallBack(response)
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    //http://127.0.0.1:8080/publisherapp2/rest/courier/enabled-statement-books/:status
    getCourier(token, status, getCourierCallBack) {
        axios.get( BASE_URL + 'rest/courier/enabled-statement-books/' + status,{
            headers: {
                'Authentication': token
            },
            timeout: 600000  //ms
        })
            .then((response) => {
                getCourierCallBack(response.data)
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

//  http://127.0.0.1:8080/publisherapp2/rest/courier/voucher-actions
    startOrCancelStatementBooksVoucher(token, courierVoucherModel, startOrCancelStatementBooksVoucherCallBack) {
        axios.put(BASE_URL + 'rest/courier/voucher-actions', courierVoucherModel,{
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                startOrCancelStatementBooksVoucherCallBack(response.data)
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })

    },

//    http://127.0.0.1:8080/publisherapp2/rest/courier/voucher-print
    voucherPrint(token, checkedItem) {
        axios.post( BASE_URL + 'rest/courier/voucher-print', {
            voucherList: checkedItem
        }, {
            responseType: 'blob',
            headers: {
                'Authentication': token,
            }
        })
            .then((response) => {
                utils.downLoadPDF(response);
                store.commit('setLoadingModal', false);
            })
            .catch((error) =>{
                properties.getErrorMessage('{error}Κάτι πήγε στραβά με τη δημιουργία του αρχείου');
                store.commit('setLoadingModal', false);
            })
    },

//     http://127.0.0.1:8080/publisherapp2/getDistributionStatus/
    getDistributionStatus(token, getDistributionStatusCallBack){

        axios.get( BASE_URL + 'getDistributionStatus', {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) =>{
            getDistributionStatusCallBack(response.data)
        })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

//    http://127.0.0.1:8080/publisherapp2/getDistributionFile/?downloadType=declaration
    getDistributionFile(token, downloadType, getDistributionFileCallBack){

        axios.get( BASE_URL + 'getDistributionFile/?downloadType=' + downloadType, {
            responseType: 'blob',
            headers: {
                'Authentication': token,
            }
        })
            .then((response) => {
                getDistributionFileCallBack(response)
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    //http://127.0.0.1:8080/publisherapp2/rest/user/eudoxus-membership
    setEudoxusMembershipForPublisher(token, eudoxusMembershipRequestModel, setEudoxusMembershipForPublisherCallBack){

        axios.put( BASE_URL + 'rest/user/eudoxus-membership', eudoxusMembershipRequestModel, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) =>{
                setEudoxusMembershipForPublisherCallBack(response.data)
            })
            .catch((error) =>{
                //properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    redirectToBookstore(callBack){

        axios.put( BASE_URL + 'rest/user/e-bookstore', '',{
            headers: {
                'Authentication': utils.getLocalStorage('token'),
                'Content-Type': 'application/json'
            }
        })
            .then((response) =>{
                callBack(response.data)
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    //http://127.0.0.1:8080/publisherapp2/rest/pricing/submit
    submitPricingForBook(token, bookPricingObject, submitPricingForBookCallback) {
        axios.post( BASE_URL + 'rest/pricing/submit', bookPricingObject, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                submitPricingForBookCallback(response.data);
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    //http://127.0.0.1:8080/publisherapp2/rest/pricing/temp-save
    tempSavePricingForBook(token, bookPricingObject, submitPricingForBookCallback) {
        axios.post( BASE_URL + 'rest/pricing/temp-save', bookPricingObject, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                submitPricingForBookCallback(response.data);
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    //http://127.0.0.1:8080/publisherapp2/rest/pricing/calculate
    calculateBookPricingInfo(token, bookPricingObject, submitPricingForBookCallback) {
        axios.put( BASE_URL + 'rest/pricing/calculate', bookPricingObject, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                submitPricingForBookCallback(response.data);
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    //http://127.0.0.1:8080/publisherapp2/rest/pricing/data
    getBookPricingInfo(token, bookPricingObject, submitPricingForBookCallback) {
        axios.put( BASE_URL + 'rest/pricing/data', bookPricingObject, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                submitPricingForBookCallback(response.data);
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    //http://127.0.0.1:8080/publisherapp2/rest/pricing/data
    getBookInfo(token, bookId, getBookInfoCallback) {
        axios.put( BASE_URL + 'rest/books/info', bookId, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                getBookInfoCallback(response.data);
            })
            .catch((error) =>{
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    // Statement and Delivery Report Methods
    checkReportStatus(token, reportRequest, statusCallBack) {
        axios.put( BASE_URL + 'rest/reports/status', reportRequest, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                statusCallBack(response)
            })
            .catch((error) => {
                statusCallBack(error.response);
                properties.getErrorMessage(error.response.data);
            })
    },

    createReport(token, reportRequest, createCallBack) {
        axios.put( BASE_URL + 'rest/reports/create', reportRequest, {
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                createCallBack(response)
            })
            .catch((error) => {
                createCallBack(error.response);
                properties.getErrorMessage(error.response.data);
            })
    },

    getReportFile(token, reportRequest, getCallBack) {
        axios.put( BASE_URL + 'rest/reports/get', reportRequest, {
            responseType: 'blob',
            headers: {
                'Authentication': token,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                getCallBack(response)
            })
            .catch((error) => {
                getCallBack(error.response);
                properties.getErrorMessage(error.response.data);
            })
    },
};

export default requests